module.exports = __webpack_public_path__ + "img/bau.85bd6bc.svg";